'use client';

import { usePulseTracker } from '@cineamo/pulse/src/react/PulseProvider';
import { trackedEntity } from '@cineamo/pulse/src/subject';
import { useEffect } from 'react';

type InterestTrackerProps = {
    contentId: number;
    movieId?: number;
    showingId?: number;
    showingTagIds?: number[];
    page?: string;
};

export function InterestTracker({ contentId, movieId, showingId, showingTagIds, page }: InterestTrackerProps) {
    const { track } = usePulseTracker();

    useEffect(() => {
        track({
            ...trackedEntity({ movieId, contentId }),
            event_type: 'page_view',
            context: {
                ...(showingId && { showing_id: showingId }),
                ...(showingTagIds?.length && { showing_tag_ids: showingTagIds }),
                ...(page && { page })
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentId]);

    return null;
}
